import React from "react";
import { _t } from "app/i18n/i18n";
import ErrorBoundary from "lib/ErrorBoundary";
import { CoverageFilters } from "./parts/CoverageFilters";
import { CoverageDisclaimer } from "./parts/Disclaimer";
import { CoverageDownloadLink } from "./parts/CoverageDownloadLink";
import { CoverageTable } from "./parts/CoverageTable/CoverageTable";
import { IndustryGroupsDataProvider } from "./data/IndustryGroupsDataProvider";
import { useCoverageData } from "./data/CoverageDataProvider";

export function CoveragePage(props) {
  const defaulTableContainerStyle = { marginLeft: 16, marginRight: 16 };
  return <Coverage {...props} tableContainerStyle={defaulTableContainerStyle} />;
}
export function Coverage(props) {
  const { rows, hits, isLoading, isError, onPage } = useCoverageData();
  const [gicsLevel2Names] = IndustryGroupsDataProvider();

  return (
    <ErrorBoundary>
      <CoverageDetails gicsLevel2Names={gicsLevel2Names} data={{ rows, hits, isLoading, isError, onPage }} {...props} />
    </ErrorBoundary>
  );
}

export function CoverageDetails({ data, showFilters = true, showHeader = true, gicsLevel2Names, tableContainerStyle }) {
  return (
    <ErrorBoundary>
      <div style={tableContainerStyle}>
        {showHeader && <h4 className="font-weight-lighter mt-3 d-none d-md-block">{_t("Equity Coverage")}</h4>}
        {showFilters && <CoverageFilters gicsLevel2Names={gicsLevel2Names} />}
        <CoverageTable data={data} />
        <CoverageDownloadLink />
      </div>
      <CoverageDisclaimer />
    </ErrorBoundary>
  );
}
